import React, { useContext } from "react";
import { ScrollPage } from "@appidea/react-scroll-motion";
import styles from "./Cards.module.scss";
import classNames from "classnames";
import style from "../../../App.module.scss";
import CardsSwiper from "../../../components/CardsSwiper/CardsSwiper";
import { colors } from "../../../colors";
import { getMessage, Message, MessageContext } from "@messageformat/react";

import vAdmin from "../../assets/v_admin.webp";
import vAi from "../../assets/v_ai.webp";
import bottles from "../../assets/bottles.png";
import cropPos from "../../assets/crop-pos.webp";
import kioskPos from "../../assets/kkiosk.webp";

const Cards = ({ page }) => {
  const isSmallScreen = window.innerWidth < 600;
  const isShortScreen = window.innerHeight < 700;
  const messageContext = useContext(MessageContext);

  const cardContents = [
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card1.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card1.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card1.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card1.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card1.description",
      )(),
      image: vAdmin,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card2.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card2.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card2.youSave2")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card2.description",
      )(),
      image: bottles,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card3.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card3.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card3.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card3.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card3.description",
      )(),
      image: cropPos,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card4.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card4.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card4.youSave2")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card4.description",
      )(),
      image: kioskPos,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card5.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card5.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card5.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card5.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card5.description",
      )(),
      image: cropPos,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card6.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card6.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card6.youSave2")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card6.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card7.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card7.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card7.youSave2")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card7.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card8.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card8.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card8.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card8.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card8.description",
      )(),
      image: vAi,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card9.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card9.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card9.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card9.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card9.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card10.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card10.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card10.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card10.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card10.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card11.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card11.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card11.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card11.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card11.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card12.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card12.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card12.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card12.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card12.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card13.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card13.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card13.youSave2")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card13.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card14.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card14.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card14.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card14.youSave3")(),
        getMessage(messageContext, "landingPage.cards.cards.card14.youSave4")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card14.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card15.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card15.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card15.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card15.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card15.description",
      )(),
      image: null,
    },
    {
      title: getMessage(
        messageContext,
        "landingPage.cards.cards.card16.title",
      )(),
      youSave: [
        getMessage(messageContext, "landingPage.cards.cards.card16.youSave1")(),
        getMessage(messageContext, "landingPage.cards.cards.card16.youSave2")(),
        getMessage(messageContext, "landingPage.cards.cards.card16.youSave3")(),
      ],
      description: getMessage(
        messageContext,
        "landingPage.cards.cards.card16.description",
      )(),
      image: null,
    },
  ];

  const baseSize = isSmallScreen ? 1.3 : 1;
  const size = isShortScreen ? baseSize * 3 : baseSize;

  return (
    <div
      style={{
        background: colors.grayLight,
        display: "flex",
        flexDirection: "column",
        padding: "20px 0",
        zIndex: 999,
        position: "relative",
      }}
    >
      {/* Header */}
      <div
        className={styles.container}
        style={{ marginTop: "40px", marginBottom: "40px" }}
      >
        <div
          style={{ textAlign: "center" }}
          className={classNames(style.heading)}
        >
          <span>
            <Message id="landingPage.cards.header" />
          </span>
          <h2>
            <Message id="landingPage.cards.title" />
          </h2>
        </div>
      </div>

      <CardsSwiper cards={cardContents} />
    </div>
  );
};

export default Cards;
